import styled from "styled-components";

export const Sidebar = styled.div`
  width: 250px;
  background: #fff;
  border-right: 1px solid #ddd;
  padding: 20px;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
`;

export const CalcList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const CalcItem = styled.li`
  padding: 10px;
  margin-bottom: 8px;
  background: ${({ $active }) => ($active ? "#e6f0ff" : "#f9f9f9")};
  border-radius: 6px;
  cursor: pointer;
  font-weight: ${({ $active }) => ($active ? "600" : "500")};
  color: ${({ $active }) => ($active ? "#1d4ed8" : "#333")};
  &:hover {
    background: #e6f0ff;
  }
`;

export const MainPanel = styled.div`
  flex: 1;
  padding: 0px 0px 0px 20px;
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

export const FranjaTitle = styled.div`
  background-color: #9cc5f98a;
  color: #333;
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 20px;
  font-size: var(--app-font-size);
  border-radius: 12px 12px 0 0;
`;

export const FranjaTitleMain = styled.span`
  white-space: nowrap;
`;

export const FranjaTitleSub = styled.span`
  margin-left: 18px;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GridComplement = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  gap: 12px;
  padding: 20px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
  padding: 20px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: var(--app-font-size);
  border: 1px solid #ccc;
  border-radius: 8px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  font-size: var(--app-font-size);
  border: 1px solid #ccc;
  border-radius: 8px;
`;

export const IconButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 20px;
`;

export const Result = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  font-size: var(--app-font-size);
  font-weight: bold;
  color: ${({ value }) => (value < 60 ? "#d9534f" : "#28a745")};
  margin-top: 5px;
`;

export const FrameWrapper = styled.div`
  width: 100%;
  padding: 0 20px 20px 20px;
`;

export const StyledFrame = styled.iframe`
  width: 100%;
  height: ${({ $height }) => `${$height}px`};
  border: none;
  background: #fff;
  display: block;
`;

export const FrameEmptyState = styled.div`
  margin: 20px;
  padding: 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
`;

export const FrameErrorState = styled.div`
  margin: 0 0 12px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 12px;
  border: 1px solid #fecaca;
`;

export const StructuredWrapper = styled.div`
  width: 100%;
  padding: 20px;
`;

export const StructuredGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
`;

export const StructuredField = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${({ $span }) => ($span >= 2 ? "1 / -1" : "auto")};
`;

export const StructuredHint = styled.span`
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
`;

export const StructuredResult = styled.div`
  margin-top: 16px;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  background: #ffffff;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StructuredResultLabel = styled.strong`
  font-size: 14px;
  color: #0f172a;
`;

export const StructuredResultValue = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: ${({ $color }) => $color || "#0f172a"};
`;

export const StructuredResultSecondary = styled.div`
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StructuredResultSecondaryLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #334155;
`;

export const StructuredResultSecondaryValue = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  color: #334155;
`;

export const StructuredResultHelp = styled.small`
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
`;
